import React from "react";
import PropTypes from "prop-types";
import { Link } from "gatsby-plugin-react-i18next";

const ConditionalLink = ({
  children,
  link,
  sameTab,
  className,
  supportReason,
  external,
  ...rest
}) => {
  if (!link) {
    return <a className={className}>{children}</a>;
  }
  const isNotGatsbyLink =
    link?.startsWith("https://") || link?.startsWith("tel:");

  if (isNotGatsbyLink || external) {
    return (
      <a
        href={link}
        className={className}
        target={!sameTab ? "_blank" : null}
        rel="noreferrer noopener">
        {children}
      </a>
    );
  }

  return (
    <Link
      to={link}
      state={
        supportReason && {
          reason: supportReason,
        }
      }
      className={className}
      {...rest}>
      {children}
    </Link>
  );
};

ConditionalLink.defaultProps = {
  sameTab: false,
};

ConditionalLink.propTypes = {
  sameTab: PropTypes.bool,
};

export default ConditionalLink;
